module.exports = __webpack_public_path__ + "static/img/P3.c371b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/P3.png
// module id = LzEh
// module chunks = 0